import api from '../utils/api';

export const login = async (credentials) => {
  try {
    const response = await api.post('/api/auth/login', credentials);
    console.log("response.data", response.data)
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const refreshToken = async (refreshToken) => {
  console.log("refresh-token", refreshToken)
  try {
    const response = await api.post('/api/auth/refresh-token', {refreshToken} );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      throw new Error('Refresh token expired. Please log in again.');
    } else {
      throw new Error('Failed to refresh token.');
    }
  }
};